import { Platform } from "react-native";
import { SafeAreaView as SAV, useSafeAreaInsets } from "react-native-safe-area-context";

const SafeAreaView = ({ children, style }) => {
  const newStyle = (oldstyle) => {
    if (oldstyle && (Platform.OS==="ios")) {
      const _style =
      oldstyle ? (Array.isArray(oldstyle) ? Object.assign({}, ...oldstyle) : oldstyle):undefined;

        const insets = useSafeAreaInsets();
      let marg = 0;
      if (_style.marginTop)
        marg = _style.marginTop;
      else if (_style.marginVertical)
        marg = _style.marginVertical;
      else if (_style.margin)
        marg = _style.margin;

      return {..._style, marginTop: marg-insets.top};
    }
    return oldstyle;
  }
  return (
    <SAV style={newStyle(style)}>
      {children}
    </SAV>
  );
};

export default SafeAreaView;

